import { NetworkError } from '../../state-machine/actions/genericActions';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { Application, HardDecline, SoftDecline, UpdateDebitErrors } from '../../gql/graphql';
import { setAppStatusParams } from '../../helpers/url/url.helpers';
// type is slightly different to get the null off application
export type AuthorizeCardResult = {
  application?: Application;
  authorizeCardErrors: UpdateDebitErrors[];
  // parsed here for easy usage
  hardDeclineError?: HardDecline;
  softDeclineError?: SoftDecline;
};

const authorizeCard = async (applicationId: number): Promise<AuthorizeCardResult> => {
  try {
    const response = await applicationFormService.authorizeCard({ applicationId });
    const returnPayload = {
      application: (response?.data?.authorizeCard?.application as Application) ?? undefined,
      authorizeCardErrors: (response?.data?.authorizeCard?.authorizeCardErrors as UpdateDebitErrors[]) || [],
      hardDeclineError: (response?.data?.authorizeCard?.authorizeCardErrors?.find((err) => err.__typename === 'HardDecline') as HardDecline) || undefined,
      softDeclineError: (response?.data?.authorizeCard?.authorizeCardErrors?.find((err) => err.__typename === 'SoftDecline') as SoftDecline) || undefined,
    };
    if (returnPayload.authorizeCardErrors.length === 0 && !returnPayload.hardDeclineError && !returnPayload.softDeclineError) setAppStatusParams('approved');

    return returnPayload;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default authorizeCard;
